import { ROUTES as AppointmentAdmin } from "../Login/routes";

export const ROUTES = [...AppointmentAdmin];
